import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackMessageComponent, SnackMessageData } from './snack-message.component';

/** Opens the legacy-styled error/success toast (`panelClass: snackbar-error|success`). */
@Injectable({ providedIn: 'root' })
export class SnackMessageService {
  private readonly snackBar = inject(MatSnackBar);

  error(title: string, message: string, duration = 10000): void {
    this.open({ type: 'error', title, message }, ['snackbar-error'], duration);
  }

  success(title: string, message: string, duration = 10000): void {
    this.open({ type: 'success', title, message }, ['snackbar-success'], duration);
  }

  private open(data: SnackMessageData, panelClass: string[], duration: number): void {
    this.snackBar.openFromComponent(SnackMessageComponent, {
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      data,
      panelClass,
    });
  }
}
